'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dhis_highcharts = require('./dhis_highcharts');

var _dhis_highcharts2 = _interopRequireDefault(_dhis_highcharts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    dhis_highcharts: _dhis_highcharts2.default
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/store/adapters/index.js
 ** module id = 223
 ** module chunks = 0 1
 **/